<template>
    <div id="layout-config">
        <div class="layout-config" :class="{ 'layout-config-active': configActive }" @click="onConfigClick">
            <h5>Tipo Menu</h5>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="static" v-model="d_menuMode" id="mode1" @change="changeMenuMode('static')"></RadioButton>
                <label for="mode1">Statico</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="overlay" v-model="d_menuMode" id="mode2" @change="changeMenuMode('overlay')"></RadioButton>
                <label for="mode2">Overlay</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="slim" v-model="d_menuMode" id="mode3" @change="changeMenuMode('slim')"></RadioButton>
                <label for="mode3">Mini</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="horizontal" v-model="d_menuMode" id="mode4" @change="changeMenuMode('horizontal')"></RadioButton>
                <label for="mode4">Orizzontale</label>
            </div>
            <hr />

            <h5>Tema App</h5>
            <div class="field-radiobutton">
                <RadioButton name="colorScheme" value="dark" v-model="d_colorScheme" id="theme1" @change="changeColorScheme('dark')"></RadioButton>
                <label for="theme1">Scuro</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="colorScheme" value="dim" v-model="d_colorScheme" id="theme2" @change="changeColorScheme('dim')"></RadioButton>
                <label for="theme2">Medio</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="colorScheme" value="light" v-model="d_colorScheme" id="theme3" @change="changeColorScheme('light')"></RadioButton>
                <label for="theme3">Chiaro</label>
            </div>

            <hr />

            <!-- <h5>Stile input</h5>
            <div class="field-radiobutton">
                <RadioButton id="input_outlined" name="inputstyle" value="outlined" :modelValue="inputStyle" @update:modelValue="onChange" />
                <label for="input_outlined">Con bordi</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton id="input_filled" name="inputstyle" value="filled" :modelValue="inputStyle" @update:modelValue="onChange" />
                <label for="input_filled">Con riempimento</label>
            </div>

            <hr /> -->

            <!-- <h5>Effetto onda</h5>
            <InputSwitch :modelValue="rippleActive" @update:modelValue="onRippleChange"  /> -->
            <h5>Mostra prezzi</h5>
            <InputSwitch :modelValue="showPrices" @update:modelValue="onShowPricesChange"  />

            <hr />

            <h5>Mostra costi</h5>
            <InputSwitch :modelValue="showCosts" @update:modelValue="onShowCostsChange"  />

            <hr />

            <h5>Tema Menu</h5>
            <div class="layout-themes" v-if="d_colorScheme === 'light'">
                <div v-for="theme in menuThemes" :key="theme.name">
                    <a style="cursor: pointer" @click="changeMenuTheme(theme.name, theme.logoColor, theme.componentTheme)" :title="theme.name" :style="{ 'background-color': theme.color }"></a>
                </div>
            </div>
            <div v-if="d_colorScheme !== 'light'">
                <p>I temi del menu sono disponibili solo in modalità chiara e modalità di menu Statico, Mini e Overlay.</p>
            </div>

            <hr />

            <h5>Tema Componenti</h5>
            <div class="layout-themes">
                <div v-for="theme in componentThemes" :key="theme.name">
                    <a style="cursor: pointer" @click="changeComponentTheme(theme.name)" :title="theme.name" :style="{ 'background-color': theme.color }"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const debug = require('debug')('xlite-web-client:appconfig')

export default {
    name: "AppConfig",
    emits: ["config-button-click", "config-click", "update:layoutMode", "update:menuTheme", "update:colorScheme"],
    props: {
        configActive: {
            type: Boolean,
            default: null,
        },
        configClick: {
            type: Boolean,
            default: null,
        },
        colorScheme: String,
        menuTheme: String,
        layoutMode: String
    },
    mounted(){
        //window.transList = new Array();

        // Layout mode
        const storeLayoutMode = this.$store.state.operatorPreferences.layoutMode ?? this.layoutMode
        this.d_menuMode = storeLayoutMode
        this.changeMenuMode(storeLayoutMode)

        // Color scheme
        const storeColorScheme = this.$store.state.operatorPreferences.colorScheme ?? this.colorScheme
        this.d_colorScheme = storeColorScheme
        this.changeColorScheme(storeColorScheme)
        
        // Input Style
        const storeInputStyle = this.$store.state.operatorPreferences.inputStyle ?? this.inputStyle
        this.onChange(storeInputStyle)

        // Ripple active
        const storeRippleActive = this.$store.state.operatorPreferences.rippleActive ?? this.rippleActive
        this.onRippleChange(storeRippleActive)

        // Show prices
        const storeShowPrices = this.$store.state.operatorPreferences.showPrices ?? this.showPrices
        this.onShowPricesChange(storeShowPrices)

        // Show costs
        const storeShowCosts = this.$store.state.operatorPreferences.showCosts ?? this.showCosts
        this.onShowCostsChange(storeShowCosts)

        if(storeColorScheme == 'light'){
            setTimeout(() => {
                // Menu theme
                const storeMenuThemeName = this.$store.state.operatorPreferences.menuTheme.name ?? this.menuColor
                const storeMenuThemeLogoColor = this.$store.state.operatorPreferences.menuTheme.logoColor ?? this.logoColor
                const storeMenuThemeComponentTheme = this.$store.state.operatorPreferences.menuTheme.componentTheme === undefined ? this.default_componentTheme : this.$store.state.operatorPreferences.menuTheme.componentTheme
                this.changeMenuTheme(storeMenuThemeName, storeMenuThemeLogoColor, storeMenuThemeComponentTheme)
            }, 400)
        } else {
            setTimeout(() => {
                // Component theme
                const storeMenuThemeComponentTheme = this.$store.state.operatorPreferences.menuTheme.componentTheme === undefined ? this.default_componentTheme : this.$store.state.operatorPreferences.menuTheme.componentTheme
                this.changeComponentTheme(storeMenuThemeComponentTheme)
            }, 400)
        }
    },
    data() {
        return {
            menuThemes: [
                {
                    name: "white",
                    color: "#ffffff",
                    logoColor: "dark",
                    componentTheme: null,
                },
                {
                    name: "darkgray",
                    color: "#343a40",
                    logoColor: "white",
                    componentTheme: null,
                },
                {
                    name: "blue",
                    color: "#1976d2",
                    logoColor: "white",
                    componentTheme: "blue",
                },
                {
                    name: "bluegray",
                    color: "#455a64",
                    logoColor: "white",
                    componentTheme: "lightgreen",
                },
                {
                    name: "brown",
                    color: "#5d4037",
                    logoColor: "white",
                    componentTheme: "cyan",
                },
                {
                    name: "cyan",
                    color: "#0097a7",
                    logoColor: "white",
                    componentTheme: "cyan",
                },
                {
                    name: "green",
                    color: "#388e3C",
                    logoColor: "white",
                    componentTheme: "green",
                },
                {
                    name: "indigo",
                    color: "#303f9f",
                    logoColor: "white",
                    componentTheme: "indigo",
                },
                {
                    name: "deeppurple",
                    color: "#512da8",
                    logoColor: "white",
                    componentTheme: "deeppurple",
                },
                {
                    name: "orange",
                    color: "#F57c00",
                    logoColor: "dark",
                    componentTheme: "orange",
                },
                {
                    name: "pink",
                    color: "#c2185b",
                    logoColor: "white",
                    componentTheme: "pink",
                },
                {
                    name: "purple",
                    color: "#7b1fa2",
                    logoColor: "white",
                    componentTheme: "purple",
                },
                {
                    name: "teal",
                    color: "#00796b",
                    logoColor: "white",
                    componentTheme: "teal",
                },
            ],
            componentThemes: [
                { name: "blue", color: "#42A5F5" },
                { name: "green", color: "#66BB6A" },
                { name: "lightgreen", color: "#9CCC65" },
                { name: "purple", color: "#AB47BC" },
                { name: "deeppurple", color: "#7E57C2" },
                { name: "indigo", color: "#5C6BC0" },
                { name: "orange", color: "#FFA726" },
                { name: "cyan", color: "#26C6DA" },
                { name: "pink", color: "#EC407A" },
                { name: "teal", color: "#26A69A" },
            ],
            logoColor: 'white',
            defaultLogoColor: 'white',
            menuColor: 'darkgray',
            defaultMenuColor: 'darkgray',
            componentTheme: document.getElementById("theme-css").getAttribute("href").split("/")[2],
            default_layoutMode: this.layoutMode,
            default_colorScheme: this.colorScheme,
            default_inputStyle: this.$primevue.config.inputStyle,
            default_rippleActive: this.$primevue.config.ripple,
            default_showPrices: true,
            default_showCosts: true,
            default_componentTheme: document.getElementById("theme-css").getAttribute("href").split("/")[2],
            d_colorScheme: this.colorScheme,
            d_menuMode: this.layoutMode,
            d_menuTheme: this.menuTheme
        };
    },
    computed: {
        rippleActive() {
            return this.$primevue.config.ripple;
        },
        showPrices() {
            return this.$store.state.operatorPreferences.showPrices;
        },
        showCosts() {
            return this.$store.state.operatorPreferences.showCosts;
        },
        inputStyle() {
            return this.$primevue.config.inputStyle;
        },
        storeLayoutMode() {
            return this.$store.state.operatorPreferences.layoutMode
        },
        storeColorScheme() {
            return this.$store.state.operatorPreferences.colorScheme
        },
        storeInputStyle() {
            return this.$store.state.operatorPreferences.inputStyle
        },
        storeRippleActive() {
            return this.$store.state.operatorPreferences.rippleActive
        },
        storeShowPrices() {
            return this.$store.state.operatorPreferences.showPrices
        },
        storeShowCosts() {
            return this.$store.state.operatorPreferences.showCosts
        },
        storeMenuTheme() {
            return this.$store.state.operatorPreferences.menuTheme
        }
    },
    watch: {
        storeLayoutMode: {
            handler(newValue){
                if(newValue !== null && newValue !== undefined && newValue != this.d_menuMode){
                    debug('layoutMode changed')
                } else if((newValue === null || newValue === undefined) && this.d_menuMode != this.default_layoutMode){
                    this.changeMenuMode(this.default_layoutMode)
                    this.d_menuMode = this.default_layoutMode
                }
            }
        },
        storeColorScheme: {
            handler(newValue){
                if(newValue !== null && newValue !== undefined && newValue != this.d_colorScheme){
                    debug('colorScheme changed')
                } else if((newValue === null || newValue === undefined) && this.d_colorScheme != this.default_colorScheme){
                    this.changeColorScheme(this.default_colorScheme)
                    this.d_colorScheme = this.default_colorScheme
                }
            }
        },
        storeInputStyle: {
            handler(newValue){
                if(newValue !== null && newValue !== undefined && newValue != this.inputStyle){
                    debug('inputStyle changed')
                } else if((newValue === null || newValue === undefined) && this.inputStyle != this.default_inputStyle){
                    this.onChange(this.default_inputStyle)
                }
            }
        },
        storeRippleActive: {
            handler(newValue){
                if(newValue !== null && newValue !== undefined && newValue != this.rippleActive){
                    debug('rippleActive changed')
                } else if((newValue === null || newValue === undefined) && this.rippleActive != this.default_rippleActive){
                    this.onRippleChange(this.default_rippleActive)
                }
            }
        },
        storeShowPrices: {
            handler(newValue){
                if(newValue !== null && newValue !== undefined && newValue != this.showPrices){
                    debug('showPrices changed')
                } else if((newValue === null || newValue === undefined) && this.showPrices != this.default_showPrices){
                    this.onShowPricesChange(this.default_showPrices)
                }
            }
        },
        storeShowCosts: {
            handler(newValue){
                if(newValue !== null && newValue !== undefined && newValue != this.showCosts){
                    debug('showCosts changed')
                } else if((newValue === null || newValue === undefined) && this.showCosts != this.default_showCosts){
                    this.onShowCostsChange(this.default_showCosts)
                }
            }
        },
        storeMenuTheme: {
            handler(newValue){
                if(newValue && newValue.name && newValue.logoColor && newValue.componentTheme != undefined){
                    debug('menuTheme changed')
                } else {
                    debug('Most likely logging out...')
                    setTimeout(() => {
                        this.changeMenuTheme(this.defaultMenuColor, this.defaultLogoColor, this.default_componentTheme)
                    }, 200)
                }
            },
            deep: true
        }
    },
    methods: {
        changeComponentTheme(theme) {
            debug('changeComponentTheme', `new: ${theme}`, `old: ${this.componentTheme}`)
            this.$store.dispatch('setOperatorComponentTheme', theme)
            this.componentTheme = theme
            this.changeStyleSheetUrl("theme-css", theme, 3);
        },
        onConfigButtonClick(event) {
            this.$emit("config-button-click", event);
            event.preventDefault();
        },
        onConfigClick(event) {
            this.$emit("config-click", event);
        },
        onChange(value) {
            this.$store.dispatch('setOperatorInputStyle', value)
            this.$primevue.config.inputStyle = value;
        },
        onRippleChange(value) {
            this.$store.dispatch('setOperatorRippleActive', value)
            this.$primevue.config.ripple = value;
        },
        onShowPricesChange(value) {
            this.$store.dispatch('setOperatorShowPrices', value)
        },
        onShowCostsChange(value) {
            this.$store.dispatch('setOperatorShowCosts', value)
        },
        changeMenuMode(mode) {
            this.$store.dispatch('setOperatorLayoutMode', mode)
            this.$emit("update:layoutMode", mode);
        },
        changeMenuTheme(name, logoColor, componentTheme) {
            debug('changeMenuTheme', {name, logoColor, componentTheme})
            this.logoColor = logoColor;
            this.menuColor = name;
            this.componentTheme = componentTheme;
            this.$store.dispatch('setOperatorMenuTheme', {name, logoColor, componentTheme});
            this.$emit("update:menuTheme", "layout-sidebar-" + name);
            this.changeStyleSheetUrl("theme-css", componentTheme, 2);

            const appLogoLink = document.getElementById("app-logo");
            const appLogoUrl = `layout/images/logo-${logoColor === 'dark' ? 'dark' : 'white'}.svg`;
            const horizontalLogoLink = document.getElementById("logo-horizontal");
            const horizontalLogoUrl = `layout/images/logo-${logoColor === 'dark' ? 'dark' : 'white'}.svg`;

            if (appLogoLink) {
                appLogoLink.src = appLogoUrl;
            }
            if (horizontalLogoLink) {
                horizontalLogoLink.src = horizontalLogoUrl;
            }
        },
        changeColorScheme(scheme) {
            debug('changeColorScheme', scheme)
            this.$store.dispatch('setOperatorColorScheme', scheme)
            this.$emit("update:colorScheme", scheme);
            this.changeStyleSheetUrl("layout-css", "layout-" + scheme + ".css", 1);
            this.changeStyleSheetUrl("theme-css", "theme-" + scheme + ".css", 1);

            this.changeLogo();
        },
        changeStyleSheetUrl(id, value, from) {
            const element = document.getElementById(id);
            const urlTokens = element.getAttribute("href").split("/");

            if (from === 1) {
                // which function invoked this function
                urlTokens[urlTokens.length - 1] = value;
            } else if (from === 2) {
                // which function invoked this function
                if (value !== null) {
                    urlTokens[urlTokens.length - 2] = value;
                }
            } else if (from === 3) {
                // which function invoked this function
                urlTokens[urlTokens.length - 2] = value;
            }

            const newURL = urlTokens.join("/");
            this.replaceLink(element, newURL);
        },
        changeLogo() {
            const appLogoLink = document.getElementById("app-logo");
            const mobileLogoLink = document.getElementById("logo-mobile");
            const invoiceLogoLink = document.getElementById("invoice-logo");
            const footerLogoLink = document.getElementById("footer-logo");
            const horizontalLogoLink = document.getElementById("logo-horizontal");
            const logoUrl = `layout/images/logo-${this.d_colorScheme === 'light' ? 'dark' : 'white'}.svg`;

            if (appLogoLink) {
                appLogoLink.src = `layout/images/logo-${this.d_colorScheme === 'light' ? this.logoColor : 'white'}.svg`;
            }

            if (horizontalLogoLink) {
                horizontalLogoLink.src = `layout/images/logo-${this.d_colorScheme === 'light' ? this.logoColor : 'white'}.svg`;
            }

            if (mobileLogoLink) {
                mobileLogoLink.src = logoUrl;
            }

            if (invoiceLogoLink) {
                invoiceLogoLink.src = logoUrl;
            }

            if (footerLogoLink) {
                footerLogoLink.src = logoUrl;
            }
        },
        replaceLink(linkElement, href) {
            const old = linkElement.getAttribute("href")
            //window.transList.push({execute: old != href, old: old, new: href, time: new Date().getTime()})
            if(old != href){
                if (this.isIE()) {
                    linkElement.setAttribute("href", href);
                } else {
                    const id = linkElement.getAttribute("id");
                    const cloneLinkElement = linkElement.cloneNode(true);

                    cloneLinkElement.setAttribute("href", href);
                    cloneLinkElement.setAttribute("id", id + "-clone");
                    cloneLinkElement.addEventListener("load", () => {
                        linkElement.remove();
                        /*
                        const duplicates = document.querySelectorAll(`#${id}`);
                        duplicates.forEach((duplicate) => {
                            duplicate.remove();
                        });
                        */
                        cloneLinkElement.setAttribute("id", id);
                    });

                    linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
                }
            } else {
                debug('No need to replaceLink');
            }
        },
        isIE() {
            return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
        }
    }
};
</script>
